import React, { FC } from 'react';
import styles from './InstagramIcon.scss';

export const InstagramIcon: FC = () => <div className={styles.instagramIcon} />;
